import { useState } from "react"
import InputB from "../../../components/InputB/InputB"
import { EventDTO } from "../../DTO/EventDTO"
import PropDTO from "../../DTO/PropDTO"
import { Alert, Box, Button, Stack } from "@mui/material"
import DeleteIcon from '@mui/icons-material/Delete';
import { TagSelector } from "../tags/TagSelector"
import { TagDTO } from "../../DTO/TagDTO"

/**
 * Zeigt den ausgewählten Datumszeitraum an.
 * Wenn man das Datum auswählt kriegt man eine Kalenderansicht, mit allen anderen Veranstaltungen zur Orientierung.
 * Das ganze sollte man der Einfachheit halber als Zeitstrahl darstellen
 * @param props 
 * @returns 
 */
export default function DateSelect(props: {
  event: EventDTO,
  rerenderParent?: () => void,
}) {
  const [Rerender, setRerender] = useState(0)
  let appointments = props.event.getAppointments()
  console.log('DateSelect appointments', appointments)
  if (appointments.length === 0) {
    appointments.push(new PropDTO({id: -1, key1: 'appointment', key2: makeHash(), value1: '', value2: ''}))
  }
  return <Stack spacing={2}>
    <Stack
      spacing={ 1 }
      direction="row"
      useFlexGap
      sx={{ flexWrap: 'wrap', alignContent: 'stretch' }}
    >
      {
        appointments.map((a, index) => {
          return <Appointment
            key={`appointment-${a.key2}`}
            event={props.event}
            key2={a.key2}
            title={`Zeitraum ${index + 1}`}
            rerenderParent={() => {
              props.rerenderParent && props.rerenderParent()
            }}
          />
        })
      }
    </Stack>
    <Box>
      <Button
        variant="outlined"
        onClick={async () => {
        await props.event.addAppointment(makeHash())
        setRerender(Rerender + 1)
      }}
      >Weiteren Zeitraum hinzufügen</Button>
    </Box>
  </Stack>
}

function Appointment(props: {
  event: EventDTO,
  key2: string,
  title: string,
  rerenderParent: () => void,
}) {
  const infoMsg = props.event.dateWarnMsg()
  const [Rerender, setRerender] = useState(0)
  const key2 = props.key2
  return <Stack spacing={2}
  >
    <h3>{props.title} <Button
      onClick={async () => {
        if (window.confirm('Zeitraum wirklich löschen?')) {
          await props.event.removeAppointment(key2)
          props.rerenderParent()
        }
      }}
    ><DeleteIcon /></Button></h3>
    <Box>
      <label className={'EditFieldLabel'}>
        Von:
      </label>
      <InputB
        value={props.event.getAppointmentStart(key2)}
        type={'date'}
        returnVal={(v) => {
          props.event.setAppointmentStart(key2, v)
          setRerender(Rerender + 1)
        }}
      />
    </Box>
    <Box>
      <label className={'EditFieldLabel'}>
        Bis:
      </label>
      <InputB
        value={props.event.getAppointmentEnd(key2)}
        type={'date'}
        returnVal={(v) => {
          props.event.setAppointmentEnd(key2, v)
          setRerender(Rerender + 1)
        }}
      />
    </Box>
    <Box>
      <label className={'EditFieldLabel'}>
        Startzeit:
      </label>
      <InputB
        value={props.event.getPropV1(key2, 'startTime') || '09:00'}
        type={'time'}
        returnVal={(v) => {
          props.event.addProp(key2, 'startTime', v)
          setRerender(Rerender + 1)
        }}
      />
    </Box>
    <Box>
      <label className={'EditFieldLabel'}>
        Endzeit:
      </label>
      <InputB
        value={props.event.getPropV1(key2, 'endTime') || '17:00'}
        type={'time'}
        returnVal={(v) => {
          props.event.addProp(key2, 'endTime', v)
          setRerender(Rerender + 1)
        }}
      />
    </Box>
    <Box>
      <TagSelector
        parentId={props.event.id}
        kind={'contractState'}
        mode={'list'}
        selectedTags={props.event.getTagsByKind('contractState', `tag-${props.key2}`)}
        selectTag={async (tag: TagDTO, single: boolean) => {
          await props.event.setTag(tag, single, `tag-${props.key2}`)
          if (props.rerenderParent) { props.rerenderParent() }
        }}
        unsetTag={async (tag: TagDTO) => {
          const prop = props.event.getProp('tag', `tag-${props.key2}`)
          if (!prop) { return }
          const value1Arr = prop.value1.replace(/SEMICOLONMARK/g, ';').split(';')
          const value1 = value1Arr.filter(v => v !== `${tag.id}`).join(';')
          await props.event.addProp('tag', `tag-${props.key2}`, value1)
          await props.event.unsetTagIfNotNeeded(`tag-${props.key2}`, tag.id);
          if (props.rerenderParent) { props.rerenderParent() }
        }}
        readMode={false}
      />
    </Box>
    <Box>
      <TagSelector
        parentId={props.event.id}
        kind={'billingStatus'}
        mode={'list'}
        selectedTags={props.event.getTagsByKind('billingStatus', `tag-${props.key2}`)}
        selectTag={async (tag: TagDTO, single: boolean) => {
          await props.event.setTag(tag, single, `tag-${props.key2}`)
          if (props.rerenderParent) { props.rerenderParent() }
        }}
        unsetTag={async (tag: TagDTO) => {
          const prop = props.event.getProp('tag', `tag-${props.key2}`)
          if (!prop) { return }
          const value1Arr = prop.value1.replace(/SEMICOLONMARK/g, ';').split(';')
          const value1 = value1Arr.filter(v => v !== `${tag.id}`).join(';')
          await props.event.addProp('tag', `tag-${props.key2}`, value1)
          await props.event.unsetTagIfNotNeeded(`tag-${props.key2}`, tag.id);
          if (props.rerenderParent) { props.rerenderParent() }
        }}
        readMode={false}
      />
    </Box>
    {
      infoMsg && infoMsg.kind !== 'okay' &&
      <Alert
        severity={infoMsg.className as 'success' | 'info' | 'warning' | 'error'}
      >{infoMsg.msg}</Alert>
    }
  </Stack>
}

function makeHash() {
  return `${new Date().getTime()}`
}
